import React from "react";
import { Link } from "react-router";

const FooterLinks = ({ title, links }) => {
    return (
        <div className="footer-column">
            <h3 className="mb-4 text-lg font-semibold">{title}</h3>
            <ul className="space-y-2 text-gray-400">
                {links.map(({ label, href, external, isRoute }) => (
                    <li
                        key={label}
                        className="group flex items-center transition-all duration-300 hover:translate-x-2"
                    >
                        <span className="mr-2 h-1.5 w-1.5 rounded-full bg-blue-500" />
                        {isRoute ? (
                            <Link to={href} className="transition-colors hover:text-white">
                                {label}
                            </Link>
                        ) : (
                            <a
                                href={href}
                                target={external ? "_blank" : undefined}
                                rel={external ? "noreferrer" : undefined}
                                className="transition-colors hover:text-white"
                            >
                                {label}
                            </a>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FooterLinks;
